import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import { TextButton } from '@gemini/ui';
import { ArrowRightIcon } from '@gemini/icons';
import Container from '@/components/structure/Container';
import { useContact } from '@/contexts/brandConfiguration/hooks';
import { useTranslation } from '@/hooks/useTranslations';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import BlockTitle from '@/components/structure/BlockTitle';
const TextContact = ({ textLeft, locales, cta, t, }) => {
    const { isDesktop } = useBreakpoint();
    return (_jsxs(Box, { flex: {
            'breakpoint.base': '1 1 100%',
            'breakpoint.lg': '0 0 50%',
        }, color: {
            'breakpoint.base': 'color.content.constant.black',
            'breakpoint.lg': 'color.content.constant.white',
        }, display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", paddingRight: {
            'breakpoint.base': 'spacing.none',
            'breakpoint.lg': textLeft ? 'spacing.none' : 'spacing.128',
        }, paddingLeft: {
            'breakpoint.base': 'spacing.none',
            'breakpoint.lg': textLeft ? 'spacing.128' : 'spacing.none',
        }, transform: textLeft ? 'scaleX(-1)' : 'none', children: [_jsx(Box, { marginBottom: "spacing.4", children: _jsx(BlockTitle, { as: "h2", children: t(`${locales}.title`) }) }), _jsx(Box, { typography: "typography.body.16.regular", marginBottom: "spacing.16", children: t(`${locales}.subtitlepart1`) }), _jsx(Box, { typography: "typography.body.16.regular", marginBottom: "spacing.32", children: t(`${locales}.subtitlepart2`) }), _jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.32", children: _jsx(TextButton, { href: cta, variant: isDesktop ? 'inverted' : 'default', icon: ArrowRightIcon, iconPosition: "end", isExternal: true, children: t(`${locales}.cta`) }) })] }));
};
export const Contact = ({ pageConfiguration, landingType, isFAQDisplayed, }) => {
    const { t } = useTranslation();
    const { img, cta, textLeft } = useContact(pageConfiguration, landingType);
    const { isDesktop, isMobile } = useBreakpoint();
    const image = isDesktop ? img.desktop : isMobile ? img.mobile : img.tablet;
    // const prefix = usePrefixI18n()!
    const locales = `fsrbo.generic.contact`;
    return (_jsxs(Container, { ...(!isFAQDisplayed
            ? {
                marginTop: {
                    'breakpoint.base': 'spacing.32',
                    'breakpoint.lg': 'spacing.80',
                },
            }
            : {}), marginBottom: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.80',
        }, children: [_jsx(Box, { as: "div", maxWidth: "100%", height: {
                    'breakpoint.base': '328px',
                    'breakpoint.md': '466px',
                }, backgroundImage: `url(${image})`, backgroundPosition: {
                    'breakpoint.base': 'center',
                    'breakpoint.md': 'left',
                    'breakpoint.lg': 'center',
                }, backgroundSize: {
                    'breakpoint.base': 'cover',
                    'breakpoint.lg': 'contain',
                }, display: "flex", flexDirection: "row-reverse", borderRadius: {
                    'breakpoint.base': 'radius.8',
                    'breakpoint.lg': 'radius.16',
                }, transform: textLeft ? 'scaleX(-1)' : 'none', children: isDesktop && (_jsx(TextContact, { textLeft: textLeft, locales: locales, cta: cta, t: t })) }), !isDesktop && (_jsx(Box, { backgroundColor: "color.surface.constant.white.default", borderRadius: {
                    'breakpoint.base': 'radius.none',
                    'breakpoint.md': 'radius.16',
                }, marginTop: "-spacing.32", paddingVertical: "spacing.16", paddingHorizontal: {
                    'breakpoint.base': 'spacing.none',
                    'breakpoint.md': 'spacing.16',
                }, children: _jsx(TextContact, { locales: locales, cta: cta, t: t }) }))] }));
};
